module.exports = __webpack_public_path__ + "media/assets/images/flags/ss-595284a05c31a045020e47581e31ed96.svg";